<template>
  <div class="prize-page" v-if="list && list.length">
    <div class="prize-data">
      <div class="prize-title">
        <img
          class="title-image"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/ac42b80d8bb7c69dbc5a0963e802c4de_wh=294_84.png"
          alt=""
        />
        <div
          class="prize-container"
          v-if="
            data &&
            data.data.current_date_little_awards &&
            data.data.current_date_little_awards.length
          "
        >
          <van-notice-bar :scrollable="false" background="rgba(255,255,255,0)">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="2000"
              :touchable="false"
              :show-indicators="false"
            >
              <van-swipe-item
                class="swipe-item"
                v-for="(item, index) in data.data.current_date_little_awards"
                :key="index"
                >{{ item.truename }} {{ item.prize_name }}*{{
                  item.num
                }}</van-swipe-item
              >
            </van-swipe>
          </van-notice-bar>
        </div>
      </div>
      <div class="prize-limit">
        <PaoMaDeng
          :list="list"
          :touchMove="false"
          direction="vertical"
          :step="list.length < 9 ? 0 : 0.7"
        >
          <div
            class="prize-list"
            :class="{ 'prize-list-disabled': list.length < 9 }"
          >
            <div class="prize-item" v-for="(item, index) in list" :key="index">
              <div class="name-and-store"
                >{{ item.truename }} {{ item.shop_name }}</div
              >
              <div class="fire-image"></div>
              <div class="prize">
                <div class="prize-name">{{ item.prize_name }}</div>
                <div class="prize-num"> *{{ item.num }}</div>
              </div>
            </div>
          </div>
        </PaoMaDeng>
      </div>
    </div>
  </div>
</template>

<script>
import PaoMaDeng from '../../../jianmeng-coach-vote-2024/components/paomadeng.vue'
export default {
  components: { PaoMaDeng },
  props: {
    list: {
      type: [Array, null],
      default: null
    },
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClick() {
      this.$emit('all')
    }
  }
}
</script>
<style lang="scss" scoped>
.prize-data {
  margin-top: 12px;
  background: linear-gradient(348deg, #ffe9d2 0%, #ffffff 100%);
  border-radius: 10px;
  padding: 16px;
  .prize-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    .title-image {
      width: 98px;
      height: 28px;
      object-fit: contain;
    }
    .prize-container {
      overflow: hidden;
      width: 159px;
      height: 28px;
      background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/0f830e0fd530baf53fa4fca6ad0eb928_wh=477_84.png');
      background-repeat: no-repeat;
      background-size: 100%;
      .van-notice-bar {
        padding: 0px;
        height: 100%;
      }
      .notice-swipe {
        width: 159px;
        height: 28px;
        .swipe-item {
          font-weight: bold;
          font-size: 10px;
          color: #9c7440;
          line-height: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: center;
        }
      }
    }
  }
  .prize-limit {
    max-height: 369px;
    overflow: hidden;
  }
  .prize-list {
    width: 319px;
    .prize-item {
      display: flex;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 12px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 17px;
      padding-bottom: 15px;
      border-bottom: 0.5px solid rgba(5, 11, 39, 0.05);
      margin-bottom: 15px;
      .name-and-store {
        width: 105px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: MiSans, MiSans;
        font-weight: bold;
        font-size: 12px;
        color: rgba(5, 11, 39, 0.5);
        line-height: 16px;
        margin-right: 6px;
      }
      .fire-image {
        width: 62px;
        height: 18px;
        background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/3637fd1b0ff330903c0d53cd83e3451f_wh=248_72.png');
        background-repeat: no-repeat;
        background-size: 100%;
        font-family: MiSans, MiSans;
        font-weight: bold;
        line-height: normal;
        font-size: 10px;
        color: #ffffff;
        padding-left: 5px;
        display: flex;
        align-items: center;
        margin-right: 6px;
      }
      .prize {
        flex: 1;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 12px;
        color: #050b27;
        line-height: 17px;
        .prize-name {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          text-align: right;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .prize-num {
        }
      }
    }
  }
  .prize-list-disabled {
    .prize-item:last-child {
    }
  }
}
</style>
